<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/"> Home </router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/setting/index"> Setting </router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/roster/pattern/index"> Roster Setting </router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Manage Pattern
      </h6>

      <div class="container-fluid">
        <div style="border: 0px; padding: 0px; min-height: 0px" class="navbar background_color roster-list-toolbar">
          <div class="d-flex roster-search-row">
            <b-input-group size="sm" class="roster-search-group">
              <b-form-input
                id="filter-input"
                class="bdr-rad"
                v-model="filter"
                type="search"
                placeholder="Search"
              ></b-form-input>
            </b-input-group>
            <div class="roster-count">
              <span class="custom-breadcrumb">Showing {{ startRow }}-{{ endRow }} of {{ totalRows }} items.</span>
            </div>
          </div>

          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button @click="goCreate" class="btn btn-sm btn-outline-primary mb-1 mt-0 bdr-rad">Create Pattern</button>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div v-else>
              <div class="table-responsive roster-pattern-table-wrap">
                <b-table
                  responsive
                  style="font-size: small;"
                  class="table-hover roster-pattern-table"
                  :items="patterns"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  head-variant="dark"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  show-empty
                  small
                  @filtered="onFiltered"
                >
                  <template #cell(status)="row">
                    <span :class="['status-pill', row.item.status ? 'status-pill-active' : 'status-pill-inactive']">
                      {{ row.item.status ? "Active" : "Inactive" }}
                    </span>
                  </template>

                 
 <template #cell(actions)="row">
                    <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
    Action
  </button>
  <div class="dropdown-menu bdr-rad">
    <a class="dropdown-item mouse-cursor" @click="editPattern(row.item)">Update</a>
                        <a class="dropdown-item mouse-cursor" @click="togglePatternStatus(row.item)">
                          {{ row.item.status ? "Inactive" : "Active" }}
                        </a>

  </div>
</div>
 </template>


                  
                </b-table>
              </div>

              <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
                <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      patterns: [],
      isLoading: true,
      filter: null,
      filterOn: ["pattern_code", "pattern_name", "pattern_description", "status", "created_date"],
      sortBy: "pattern_code",
      sortDesc: false,
      sortDirection: "asc",
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      fields: [
        { key: "pattern_code", label: "Code", sortable: true, sortDirection: "desc" },
        { key: "pattern_name", label: "Name", sortable: true },
        { key: "pattern_description", label: "Description", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "created_date", label: "Created", sortable: true },
        { key: "actions", label: "Actions", class: "width-custom3" },
      ],
    };
  },
  computed: {
    startRow() {
      if (!this.totalRows) return 0;
      return (this.currentPage - 1) * this.perPage + 1;
    },
    endRow() {
      if (!this.totalRows) return 0;
      return Math.min(this.currentPage * this.perPage, this.totalRows);
    },
  },
  mounted() {
    this.loadMasterData();
  },
  methods: {
    rosterRequestHeaders() {
      return {
        Authorization: "Bearer " + this.access_token,
        "Content-Type": "application/json",
      };
    },
    goCreate() {
      this.$router.push("/roster/pattern/create");
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async loadMasterData() {
      this.isLoading = true;
      try {
        const { data } = await axios.get("/roster/masterdata", { headers: this.rosterRequestHeaders() });
        this.patterns = data.patterns || [];
        this.totalRows = this.patterns.length;
        this.currentPage = 1;
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isLoading = false;
      }
    },
    editPattern(pattern) {
      this.$router.push({
        path: "/roster/pattern/create",
        query: {
          id: pattern.id || 0,
          pattern_code: pattern.pattern_code || "",
          pattern_name: pattern.pattern_name || "",
          pattern_description: pattern.pattern_description || "",
          status: pattern.status ? 1 : 0,
        },
      });
    },
    async togglePatternStatus(pattern) {
      try {
        const { data } = await axios.post(
          "/roster/togglepatternstatus",
          { id: pattern.id, status: pattern.status ? 0 : 1, userid: this.userid },
          { headers: this.rosterRequestHeaders() }
        );
        if (data.status === 200) {
          await this.loadMasterData();
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
  },
};
</script>

<style>
.roster-list-toolbar {
  border: 0;
  padding: 0;
  min-height: 0;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.roster-search-row {
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.roster-search-group {
  width: 225px;
}

.roster-count {
  margin-top: 11px;
}



.status-pill {
  display: inline-block;
  padding: 0.22rem 0.5rem;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.status-pill-active {
  background: #e2f5e8;
  color: #1f7a3c;
}

.status-pill-inactive {
  background: #f2f2f2;
  color: #6b7280;
}

@media (max-width: 767.98px) {
  .roster-search-group {
    width: 100%;
  }

  .roster-count {
    margin-top: 0;
  }

  .roster-list-toolbar {
    align-items: flex-start;
  }

  .roster-search-row {
    width: 100%;
  }
}
</style>
